/**
 * Collection Filters Management
 * Handles product filtering functionality for collection pages
 * 
 * Dependencies: jQuery, GTM object for analytics
 */

class CollectionFilters {
  constructor() {
    this.selectedOptions = [];
    this.queryParams = {};
    this.isInitialized = false;
    
    // Parse current URL query parameters
    this.parseUrlParams();
    
    // Initialize filters
    this.init();
  }

  /**
   * Parse URL query parameters
   */
  parseUrlParams() {
    this.queryParams = {};
    if (location.search.length) {
      const couples = location.search.substr(1).split('&');
      for (let i = 0; i < couples.length; i++) {
        const keyValue = couples[i].split('=');
        if (keyValue.length > 1) {
          this.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
  }

  /**
   * Initialize collection filters
   */
  init() {
    if (this.isInitialized) return;
    
    this.setupFilterEvents();
    this.initializeSidebar();
    this.addFilterKeyboardSupport();
    this.isInitialized = true;
  }

  trackFilterOnListing(filterInput, eventAction) {
    if (typeof dataLayer !== 'undefined') {
      const $filterGroup = filterInput.closest('.sidebar__collection-filter');
      const filterCategory = $filterGroup.find('.toggle-custom').text().trim();
      const filterValue = filterInput.siblings('label').text().trim();
      // Track filter interaction
      dataLayer.push({
        "event": "GAevent",
        "eventCategory": "filter_on_listing",
        "eventAction": eventAction,
        "eventLabel": `${filterCategory} | ${filterValue}`
      });
    }
  }

  trackClearAllFilters() {
    if (typeof dataLayer !== 'undefined') {
      const activeFilters = $('.filter_tag').toArray().map((filter) => filter.innerText.trim()).join(' | ');
      dataLayer.push({
        "event": "GAevent",
        "eventCategory": "reset_all_filters",
        "eventLabel": activeFilters
      });
    }
  }

  trackSortingRule() {
    if (typeof dataLayer !== 'undefined') {
      const sortingRule = $('.sort-by-select__option.item-selected').text().trim();
      dataLayer.push({
        "event": "GAevent",
        "eventCategory": "sorting_on_listing",
        "eventLabel": sortingRule
      });
    }
  }

  /**
   * Setup filter events and bindings
   */
  setupFilterEvents() {
    const self = this;

    let previouslyCheckedRadioInGroup;
    // Detect if there is a previously checked radio
    $(document).on('mousedown', '[data-option-filter]', function(e) {
      previouslyCheckedRadioInGroup = $(this).parent().find('input[type="radio"]:checked');
    });
    // Support filter changes using keyboard arrows
    $(document).on('keydown', '[data-option-filter] input', function(e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        previouslyCheckedRadioInGroup = $(this).parent().find('input[type="radio"]:checked');
      }
    });

    // Handle filter checkbox changes
    $(document).on('change', '[data-option-filter] input', function() { 
      if (previouslyCheckedRadioInGroup && previouslyCheckedRadioInGroup.length > 0) {
        self.trackFilterOnListing(previouslyCheckedRadioInGroup, 'Removed');
      }
      self.trackFilterOnListing($(this), 'Added');
      self.handleFilterChange();
    });

    // Handle sort dropdown changes
    $(document).on('change', '#sort-by', function() {
      self.trackSortingRule();
      self.handleFilterChange();
    });

    // Handle collection filter dropdown
    $(document).on('change', '#tag_filter', function() {
      self.handleFilterChange();
    });

    // Handle clear filter buttons
    $(document).on('click', '[data-clear-filter]', function(e) {
      e.preventDefault();
      const filterValue = $(this).data('clear-filter');
      self.clearFilter(filterValue);
    });

    // Handle clear all filters
    $(document).on('click', '.js-clear-all-filters', function(e) {
      e.preventDefault();
      self.trackClearAllFilters();
      self.clearAllFilters();
    });

    // Handle tag removal
    this.handleTagRemoval();

    // Handle radio button deselectability for single selection mode
    this.setupRadioDeselectability();

    // Filter Show More functionality
    $('body').on('click', '.filter-show-more-btn', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const $button = $(this);
        const $filterOptions = $button.closest('.filter-options');
        const $hiddenOptions = $filterOptions.find('.filter-option-hidden');
        
        // Show all hidden options permanently
        $hiddenOptions.removeClass('filter-option-hidden').show().attr('aria-hidden', 'false');
        
        // Hide the show more button after expanding
        $button.hide().attr('aria-expanded', 'true');
    });

    // Initialize show more state on page load
    $('.filter-show-more-btn').each(function() {
        const $button = $(this);
        const $filterOptions = $button.closest('.filter-options');
        const $hiddenOptions = $filterOptions.find('.filter-option-hidden');
        
        // Initially hide the extra options
        $hiddenOptions.hide().attr('aria-hidden', 'true');
        $button.attr('aria-expanded', 'false');
    });
  }

  /**
   * Initialize sidebar filter behavior
   */
  initializeSidebar() {
    // Remove border from empty sidebar blocks
    $('.sidebar-block:empty').prev().css('border-bottom', 'none');
  }

  /**
   * Handle filter change events
   */
  handleFilterChange() {
    this.selectedOptions = [];
    let query = '';
    let currentTags = '';
    
    const siteUrl = `https://${$.url('hostname')}`;
    const url1 = $.url('1') ? `/${$.url('1')}/` : '';
    const url2 = $.url('2') ? `${$.url('2')}/` : '';
    const path = url1 + url2;
    const isBlog = (url1 === '/blogs/');

    // Handle sort dropdown
    if ($('#sort-by').length) {
      query = $('#sort-by').val();
    } else {
      query = $.url('?sort_by');
    }

    // Handle collection filter dropdown
    if ($('#tag_filter').length) {
      if ($('#tag_filter').data('default-collection') !== $('#tag_filter').val()) {
        const urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);
        
        if (urlTag !== 'all') {
          if ($.inArray(urlTag, this.selectedOptions) === -1) {
            this.selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    // Collect all checked filter options
    $('[data-option-filter] input:checked').each((index, element) => {
      this.selectedOptions.push($(element).val());
    });

    this.selectedOptions = $.makeArray(this.selectedOptions);

    // Build tags string
    $.each(this.selectedOptions, (i, value) => {
      if (i !== this.selectedOptions.length - 1) {
        currentTags += this.selectedOptions[i] + '+';
      } else {
        currentTags += this.selectedOptions[i];
      }
    });

    this.queryParams.sort_by = query;
    query = '?' + $.param(this.queryParams);

    // Handle blog filters differently
    if (isBlog) {
      if (currentTags !== '') {
        query = '';
      }
    }

    this.processUrl(path, currentTags, query);
  }

  /**
   * Process URL and update view
   */
  processUrl(path, tags, query) {
    const cleanQuery = query.replace(/\page=(\w+)&/, '');
    let urlString = '';

    if (path.includes('/blogs/')) {
      urlString = tags !== '' ? path + 'tagged/' + tags + cleanQuery : path + cleanQuery;
    } else {
      urlString = path + tags + cleanQuery;
    }

    // Store current tags for GTM
    if (typeof GTM !== 'undefined') {
      GTM.currentTags = tags;
    }

    this.updateView(urlString);
  }

  /**
   * Update collection view via AJAX
   */
  updateView(filterURL) {
    const self = this;

    // Scroll to filters before making the AJAX call, then proceed with the request
    this.scrollToFilters(function() {
      $.ajax({
        type: 'GET',
        url: filterURL,
        beforeSend: function() {
          // Add loading states
          $('.products-content').addClass('fadeOut animated loading-in-progress filter-loading');
          $('.container-filters').addClass('filter-loading');
          $('.filter-options').addClass('loading');

          // Destroy waypoints for infinite scroll
          if (typeof Waypoint !== 'undefined') {
            Waypoint.destroyAll();
          }
        },
        success: function(data) {
          self.handleSuccessResponse(data, filterURL);
          $('.filter-options').removeClass('loading');
        },
        error: function(xhr, status, error) {
          console.error('Filter AJAX error:', error);
          // Fallback to page reload
          location.replace(location.protocol + '//' + location.host + filterURL);
        },
        dataType: 'html'
      });
    });
  }

  /**
   * Handle successful AJAX response
   */
  handleSuccessResponse(data, filterURL) {
    const $data = $(data);

    // Update breadcrumbs
    const filteredBreadcrumb = $data.find('.breadcrumb_text').html();
    if (filteredBreadcrumb) {
      $('.breadcrumb_text').html(filteredBreadcrumb);
    }

    // Update pagination
    const filteredPagination = $data.find('.paginate').html();
    if (filteredPagination) {
      $('.paginate').html(filteredPagination);
    }

    // Update current tags
    const filteredCurrentTags = $data.find('.current_tags').html();
    if (filteredCurrentTags) {
      $('.current_tags').html(filteredCurrentTags);
    }

    // Update results count
    const filteredResultsCount = $data.find('.counter-filters').html();
    if (filteredResultsCount) {
      $('.counter-filters').html(filteredResultsCount);
    }

    // Update only filter options without closing dropdowns
    this.updateFilterOptions($data);

    // Update mobile filter counter
    const appliedFiltersCounter = $data.find('.applied-filters-counter').first().text();
    if (appliedFiltersCounter) {
      $('.applied-filters-counter').text(appliedFiltersCounter);
    }

    // Update browser history
    if (window.history && window.history.pushState) {
      window.history.pushState('', '', filterURL);
    }

    // Update collection products content
    const filteredProductsContent = $data.find('.products-content');
    $('.products-content').remove();
    
    // Insert new content
    filteredProductsContent.insertBefore($('.load-more__icon'));

    // Remove loading states
    $('.container-filters').removeClass('filter-loading');
    $('.products-content').removeClass('loading-in-progress filter-loading fadeOut animated');

    // Reinitialize components
    this.reinitializeComponents();

    // Update results count
    this.updateResultsCount();

    // Track GTM events
    this.trackFilterEvent();
  }

  /**
   * Update filter options without affecting dropdown states
   */
  updateFilterOptions(data) {
    const $data = $(data);
    
    // Store current accessibility state before update
    const currentAccessibilityState = this.getCurrentAccessibilityState();
    
    // Update each filter container's visibility and content
    $('.sidebar__collection-filter').each(function(index) {
      const $currentFilter = $(this);
      const $newFilter = $data.find('.sidebar__collection-filter').eq(index);
      
      if ($newFilter.length) {
        // Update the hide class based on new data
        if ($newFilter.hasClass('hide')) {
          $currentFilter.addClass('hide');
        } else {
          $currentFilter.removeClass('hide');
        }
        
        // Update the filter options content
        const $currentFilterOptions = $currentFilter.find('.filter-options');
        const $newFilterOptions = $newFilter.find('.filter-options');
        
        if ($currentFilterOptions.length && $newFilterOptions.length) {
          $currentFilterOptions.html($newFilterOptions.html());
        }
      }
    });
    
    // Restore accessibility state after update
    this.restoreAccessibilityState(currentAccessibilityState);
  }

  /**
   * Get current accessibility state of filters
   */
  getCurrentAccessibilityState() {
    const state = {
      filtersOpen: $('.dav-productlist-container').hasClass('filters-open'),
      openToggles: [],
      focusedElement: document.activeElement
    };

    // Store which filter toggles are currently open
    $('.toggle-custom.active').each(function() {
      const toggleId = $(this).attr('id');
      if (toggleId) {
        state.openToggles.push(toggleId);
      }
    });

    return state;
  }

  /**
   * Restore accessibility state after AJAX update
   */
  restoreAccessibilityState(state) {
    const $filtersRegion = $('#collection-filters');
    const isFiltersOpen = state.filtersOpen;
    
    // Restore filter options accessibility based on current state
    const $focusableElements = $filtersRegion.find('button, select, a').not('.toggle-custom, .filter-show-more-btn');
    
    if (isFiltersOpen) {
      // Filters are open - restore focusability for non-toggle elements
      $focusableElements.removeAttr('tabindex');
      
      // Restore opened toggle states and their content accessibility
      state.openToggles.forEach(toggleId => {
        const $toggle = $(`#${toggleId}`);
        const $toggleList = $toggle.nextAll('.toggle_list-custom').first();
        
        $toggle.addClass('active').attr('aria-expanded', 'true');
        $toggleList.addClass('opened');
        
        // Make elements inside opened toggle lists focusable
        $toggleList.find('input, button').removeAttr('tabindex');
      });
      
      // Make elements inside closed toggle lists unfocusable
      $('.toggle_list-custom:not(.opened)').find('input, button').attr('tabindex', '-1');
    } else {
      // Filters are closed - make all elements unfocusable
      $focusableElements.attr('tabindex', '-1');
      $('.toggle_list-custom').find('input, button').attr('tabindex', '-1');
    }

    // Add keyboard navigation support for filter inputs
    this.addFilterKeyboardSupport();

    // Attempt to restore focus if the previously focused element still exists
    this.restoreFocus(state.focusedElement);
  }

  /**
   * Attempt to restore focus to a similar element after AJAX update
   */
  restoreFocus(previouslyFocusedElement) {
    if (!previouslyFocusedElement || !previouslyFocusedElement.id) return;

    const elementId = previouslyFocusedElement.id;
    const $newElement = $(`#${elementId}`);
    
    if ($newElement.length && $newElement.is(':visible') && !$newElement.attr('tabindex') === '-1') {
      // Element still exists and is focusable, restore focus
      setTimeout(() => {
        $newElement.focus();
      }, 100);
    } else if (previouslyFocusedElement.hasAttribute('data-filter-tag')) {
      // If it was a filter input, try to find the equivalent new input
      const filterTag = previouslyFocusedElement.getAttribute('data-filter-tag');
      const $newFilterInput = $(`[data-filter-tag="${filterTag}"]`).first();
      
      if ($newFilterInput.length && $newFilterInput.is(':visible') && !$newFilterInput.attr('tabindex') === '-1') {
        setTimeout(() => {
          $newFilterInput.focus();
        }, 100);
      }
    }
  }

  /**
   * Add keyboard navigation support for filter inputs
   */
  addFilterKeyboardSupport() {
    // Remove existing handlers to avoid duplicates
    $('[data-option-filter] input').off('keydown.filterKeyboard');
    
    // Add keyboard support for filter inputs (Enter to toggle, Space for radio deselection)
    $('[data-option-filter] input').on('keydown.filterKeyboard', (e) => {
      const $input = $(e.target);
      const isRadio = $input.attr('type') === 'radio';
      
      if (e.key === 'Enter') {
        e.preventDefault();
        
        if (isRadio && $input.is(':checked')) {
          // If radio is checked and Enter is pressed, deselect it
          const filterValue = $input.val();
          this.trackFilterOnListing($input, 'Removed');
          this.clearFilter(filterValue);
          
        } else {
          // Toggle the input
          $input.prop('checked', !$input.is(':checked')).trigger('change');
        }
      } else if (e.key === ' ' && isRadio && $input.is(':checked')) {
        // Space key on checked radio to deselect
        e.preventDefault();
        const filterValue = $input.val();
        this.trackFilterOnListing($input, 'Removed');
        this.clearFilter(filterValue);
      }
    });
  }

  /**
   * Handle results count update
   */
  updateResultsCount() {
    const totalProducts = $('.products-content .product-list .product-item').length;
    const resultsText = totalProducts === 1 ? 'risultato' : 'risultati';
    
    if ($('.results-count').length) {
      $('.results-count').text(`${totalProducts} ${resultsText}`);
    }
  }

  /**
   * Scroll to filters
   */
  scrollToFilters(callback) {
    if (typeof goToPos === 'function') {
      goToPos('.dav-productlist-container');
      // goToPos doesn't provide a callback, so we use a timeout
      if (typeof callback === 'function') {
        setTimeout(callback, 500); // Assume goToPos takes ~500ms
      }
    } else {
      // Fallback scroll
      const $filtersContainer = $('.dav-productlist-container');
      if ($filtersContainer.length) {
        $('html, body').animate({
          scrollTop: $filtersContainer.offset().top
        }, 300, function() {
          // Animation complete callback
          if (typeof callback === 'function') {
            callback();
          }
        });
      } else if (typeof callback === 'function') {
        // If no container found, still call the callback
        callback();
      }
    }
  }

  /**
   * Reinitialize components after AJAX update
   */
  reinitializeComponents() {
    // Reinitialize lazy loading
    if (typeof themeLazyLoad !== 'undefined') {
      themeLazyLoad.init();
    }

    // Reinitialize infinite scroll
    if (typeof enableInfiniteScroll === 'function') {
      enableInfiniteScroll();
    }

    // Reinitialize currency conversion
    if (typeof convertCurrencies === 'function') {
      convertCurrencies();
    }

    // Reinitialize Shopify reviews
    if (typeof SPR !== 'undefined') {
      SPR.$(document).ready(function() {
        return SPR.registerCallbacks(),
          SPR.initRatingHandler(),
          SPR.initDomEls(),
          SPR.loadProducts(),
          SPR.loadBadges();
      });
    }

    // Reinitialize keyboard support for filters
    this.addFilterKeyboardSupport();
  }

  /**
   * Track filter events with GTM
   */
  trackFilterEvent() {
    if (typeof GTM === 'undefined') return;

    setTimeout(() => {
      const currentFilters = GTM.currentTags;
      if (!currentFilters) return;

      const splitCharacter = '|';
      const formattedFilters = currentFilters.split('+').join(splitCharacter).toLowerCase();

      // Track filter usage
      if (typeof gtag !== 'undefined') {
        gtag('event', 'filter_used', {
          'event_category': 'Collection',
          'event_label': formattedFilters
        });
      }
    }, 100);
  }

  /**
   * Clear specific filter
   */
  clearFilter(filterValue) {
    $(`[data-option-filter] input[value="${filterValue}"]`).prop('checked', false);
    this.handleFilterChange();
  }

  /**
   * Clear all active filters
   */
  clearAllFilters() {
    $('[data-option-filter] input:checked').prop('checked', false);
    this.handleFilterChange();
  }

  /**
   * Clear selected filter in a specific container
   */
  clearSelectedFilter(optionFilter) {
    optionFilter.find('[data-option-filter] input:checked').prop('checked', false);
    this.handleFilterChange();
  }

  /**
   * Handle filter tag removal
   */
  handleTagRemoval() {
    const self = this;
    
    $(document).on('click', '.current_tags .filter_tag', function(e) {
      e.preventDefault();
      const tagValue = $(this).data('filter-tag-value');
      const $filterInput = $(`[data-option-filter] input[value="${tagValue}"]`);

      // Track filter removal with GTM
      self.trackFilterOnListing($filterInput, 'Removed');
      
      // Uncheck corresponding filter
      $filterInput.prop('checked', false);
      
      // Trigger filter change
      self.handleFilterChange();
    });
  }

  /**
   * Setup radio button deselectability for single selection mode
   * Allows users to deselect a radio button by clicking it again
   */
  setupRadioDeselectability() {
    const self = this;
    
    // Store the state of radio buttons before click
    $(document).on('mousedown', '[data-option-filter]', function(e) {
      const $radio = $('input[type="radio"]', this);;
      $radio.data('was-checked', $radio.is(':checked'));
    });

    // Handle radio button click for deselection
    $(document).on('click', '[data-option-filter]', function(e) {
      const $radio = $('input[type="radio"]', this);
      const wasChecked = $radio.data('was-checked');
      
      // If the radio was already checked, simulate tag removal
      if (wasChecked === true) {
        e.preventDefault();
        
        // Use the existing clearFilter method with the radio's value
        const filterValue = $radio.val();
        self.trackFilterOnListing($radio, 'Removed');
        self.clearFilter(filterValue);
      }
      
      // Clean up the data attribute
      $radio.removeData('was-checked');
    });
  }
}

/*============================================================================
  Fast Collection Links - Draggable Navigation
==============================================================================*/

var fastCollectionLinks = {
  init: function(){
    const container = document.querySelector('.collection-fast-link__container');

    if (!container) return;

    // Add click tracking for crosslinks
    container.addEventListener('click', (e) => {
      const link = e.target.closest('.collection-fast-link__item');
      if (link && typeof dataLayer !== 'undefined') {
        dataLayer.push({
          "event": "GAevent",
          "eventCategory": "plp_crosslink_click",
          "eventAction": document.querySelector('.dav-main-title')?.textContent?.trim() || "",
          "eventLabel": link.textContent.trim()
        });
      }
    });

    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      moved = false;
      startX = e.pageX;
      scrollLeft = container.scrollLeft;
      container.classList.add('dragging');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) moved = true;
      container.scrollLeft = scrollLeft - walk;
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('click', (e) => {
      if (moved) {
        e.preventDefault(); //blocca click sui <a> se è stato un drag
        e.stopImmediatePropagation();
      }
    });

    //Touch support
    container.addEventListener('touchstart', (e) => {
      isDown = true;
      moved = false;
      startX = e.touches[0].pageX;
      scrollLeft = container.scrollLeft;
    }, { passive: true });

    container.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - startX) * 1.5;
      if (Math.abs(walk) > 5) moved = true;
      container.scrollLeft = scrollLeft - walk;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {
      isDown = false;
    });
  }
};

//document ready
$(function () {

    // Initialize accessibility states for filters
    function initializeFiltersAccessibility() {
        const $filtersRegion = $('#collection-filters');
        const $focusableElements = $filtersRegion.find('button, select, a').not('.toggle-custom, .filter-show-more-btn');
        
        // Since filters start hidden, make all focusable elements unfocusable
        $focusableElements.attr('tabindex', '-1');
        
        // Also initialize all toggle list contents as unfocusable (since they start closed)
        $('.toggle_list-custom').find('input, button').attr('tabindex', '-1');
    }

    // Call initialization
    initializeFiltersAccessibility();

    $('body').on('click', '.open-filters', function () {
        const $container = $('.dav-productlist-container');
        const $button = $(this);
        const $filtersRegion = $('#collection-filters');
        const $body = $('body');
        const isOpen = $container.hasClass('filters-open');

        if (!isOpen && typeof dataLayer !== 'undefined') {
          // Track filter modal opening
          dataLayer.push({
            "event": "GAevent",
            "eventCategory": "plp_modal_click",
            "eventAction": document.querySelector('.dav-main-title')?.textContent?.trim() || "",
            "eventLabel": "Filter by" // hardcoded label since specification says Possible values: “Filter by” or “Sort by”
          });
        }
        
        $container.toggleClass('filters-open');
        $button.attr('aria-expanded', !isOpen);
        $filtersRegion.attr('aria-hidden', isOpen);
        
        // Manage body scroll lock on mobile
        if (isOpen) {
            // When closing, remove scroll lock
            $body.removeClass('filters-open-mobile');
        } else {
            // When opening, add scroll lock on mobile
            $body.addClass('filters-open-mobile');
        }
        
        // Manage focusability of elements inside filters (excluding filter inputs and show-more buttons)
        const $focusableElements = $filtersRegion.find('button, select, a').not('.toggle-custom, .filter-show-more-btn');
        
        if (isOpen) {
            // When closing, make elements unfocusable
            $focusableElements.attr('tabindex', '-1');
            // Also make all toggle list contents unfocusable
            $('.toggle_list-custom').find('input, button').attr('tabindex', '-1');
        } else {
            // When opening, restore focusability
            $focusableElements.removeAttr('tabindex');
            // For toggle lists, only make opened ones focusable
            $('.toggle_list-custom.opened').find('input, button').removeAttr('tabindex');
            // Keep closed toggle lists unfocusable
            $('.toggle_list-custom:not(.opened)').find('input, button').attr('tabindex', '-1');
        }
        
        // Focus management for accessibility
        if (!isOpen) {
            // When opening, focus on the first focusable element in filters
            setTimeout(() => {
                const $firstFocusable = $filtersRegion.find('button, input, select, a').first();
                if ($firstFocusable.length) {
                    $firstFocusable.focus();
                }
            }, 100);
        }
    });

    // Handle close filters button
    $('body').on('click', '[data-close-filter-screen]', function () {
        const $container = $('.dav-productlist-container');
        const $openButton = $('.open-filters');
        const $filtersRegion = $('#collection-filters');
        const $body = $('body');
        
        $container.removeClass('filters-open');
        $openButton.attr('aria-expanded', 'false');
        $filtersRegion.attr('aria-hidden', 'true');
        
        // Remove body scroll lock
        $body.removeClass('filters-open-mobile');
        
        // Make all focusable elements inside filters unfocusable (excluding filter inputs and show-more buttons)
        const $focusableElements = $filtersRegion.find('button, select, a').not('.toggle-custom, .filter-show-more-btn');
        $focusableElements.attr('tabindex', '-1');
        
        // Also make all toggle list contents unfocusable
        $('.toggle_list-custom').find('input, button').attr('tabindex', '-1');
    });

    // Handle ESC key to close filters
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('.dav-productlist-container').hasClass('filters-open')) {
            const $container = $('.dav-productlist-container');
            const $openButton = $('.open-filters');
            const $filtersRegion = $('#collection-filters');
            const $body = $('body');
            
            $container.removeClass('filters-open');
            $openButton.attr('aria-expanded', 'false');
            $filtersRegion.attr('aria-hidden', 'true');
            
            // Remove body scroll lock
            $body.removeClass('filters-open-mobile');
            
            // Make all focusable elements inside filters unfocusable (excluding filter inputs and show-more buttons)
            const $focusableElements = $filtersRegion.find('button, select, a').not('.toggle-custom, .filter-show-more-btn');
            $focusableElements.attr('tabindex', '-1');
            
            // Also make all toggle list contents unfocusable
            $('.toggle_list-custom').find('input, button').attr('tabindex', '-1');
            
            $openButton.focus(); // Return focus to the open button
        }
    });

    // Accordion behavior for filter toggles - one at a time, closable
    $('body').on('click', '.toggle-custom', function () {
        const $this = $(this);
        const $toggleList = $this.nextAll('.toggle_list-custom').first();
        const isActive = $this.hasClass('active');
        
        if (isActive) {
            // Close this filter if it's already active
            $this.removeClass('active');
            $this.attr('aria-expanded', 'false');
            $toggleList.removeClass('opened');
            
            // Make elements inside this toggle list unfocusable
            $toggleList.find('input, button').attr('tabindex', '-1');
        } else {
            // Close all other active filters first (accordion behavior)
            $('.toggle-custom.active').removeClass('active').attr('aria-expanded', 'false');
            $('.toggle_list-custom.opened').removeClass('opened');
            
            // Make elements inside all closed toggle lists unfocusable
            $('.toggle_list-custom:not(.opened)').find('input, button').attr('tabindex', '-1');
            
            // Open this filter
            $this.addClass('active');
            $this.attr('aria-expanded', 'true');
            $toggleList.addClass('opened');
            
            // Make elements inside this opened toggle list focusable
            $toggleList.find('input, button').removeAttr('tabindex');
        }
    });

    // Custom Sort-By Dropdown functionality
    $('body').on('click', '.sort-by-select__trigger', function(event) {
        event.stopPropagation();
        const $sortBySelect = $(this).closest('.sort-by-select');
        const $optionsList = $sortBySelect.find('.sort-by-select__options-list');
        const $options = $optionsList.find('.sort-by-select__option');
        const currentlyOpen = $sortBySelect.hasClass('is-open');

        // Track sort modal opening
        if (!currentlyOpen && typeof dataLayer !== 'undefined') {
          dataLayer.push({
            "event": "GAevent",
            "eventCategory": "plp_modal_click",
            "eventAction": document.querySelector('.dav-main-title')?.textContent?.trim() || "",
            "eventLabel": "Sort by" // hardcoded label since specification says Possible values: “Filter by” or “Sort by”
          });
        }

        if (currentlyOpen) {
            $sortBySelect.removeClass('is-open');
            $(this).attr('aria-expanded', 'false');
        } else {
            $('.sort-by-select').removeClass('is-open').find('.sort-by-select__trigger').attr('aria-expanded', 'false');
            $sortBySelect.addClass('is-open');
            $(this).attr('aria-expanded', 'true');
            
            // Set proper focus management
            const $selectedOption = $options.filter('.item-selected').first();
            if ($selectedOption.length) {
                // Small delay to ensure DOM is updated
                setTimeout(() => $selectedOption.trigger('focus'), 10);
            } else {
                setTimeout(() => $options.first().trigger('focus'), 10);
            }
        }
    });

    $('body').on('click', '.sort-by-select__option', function(event) {
        event.stopPropagation();
        const $option = $(this);
        const $sortBySelect = $option.closest('.sort-by-select');
        const $options = $sortBySelect.find('.sort-by-select__option');
        const $trigger = $sortBySelect.find('.sort-by-select__trigger');

        $options.removeClass('item-selected').attr('aria-selected', 'false');
        $option.addClass('item-selected').attr('aria-selected', 'true');
        $sortBySelect.removeClass('is-open');
        $trigger.attr('aria-expanded', 'false').trigger('focus');
        console.log($option.data('value'));
        $('#sort-by').val($option.data('value')).trigger('change');
    });

    // Sort-by keyboard navigation on trigger
    $('body').on('keydown', '.sort-by-select__trigger', function(event) {
        const $trigger = $(this);
        const $sortBySelect = $trigger.closest('.sort-by-select');
        const $optionsList = $sortBySelect.find('.sort-by-select__options-list');
        const $options = $optionsList.find('.sort-by-select__option');
        const isOpen = $sortBySelect.hasClass('is-open');

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            $trigger.trigger('click');
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            if (!isOpen) {
                $trigger.trigger('click');
            }
            // Focus the first/last option based on arrow direction
            if (event.key === 'ArrowDown') {
                $options.first().trigger('focus');
            } else {
                $options.last().trigger('focus');
            }
        } else if (event.key === 'Escape' && isOpen) {
            $sortBySelect.removeClass('is-open');
            $trigger.attr('aria-expanded', 'false');
        }
    });

    // Sort-by keyboard navigation
    $('body').on('keydown', '.sort-by-select__option', function(event) {
        const $option = $(this);
        const $sortBySelect = $option.closest('.sort-by-select');
        const $options = $sortBySelect.find('.sort-by-select__option');
        const $trigger = $sortBySelect.find('.sort-by-select__trigger');
        const currentIndex = $options.index($option);

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            $option.trigger('click');
        } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            const nextIndex = (currentIndex + 1) % $options.length;
            $options.eq(nextIndex).trigger('focus');
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            const prevIndex = (currentIndex - 1 + $options.length) % $options.length;
            $options.eq(prevIndex).trigger('focus');
        } else if (event.key === 'Escape') {
            event.preventDefault();
            $sortBySelect.removeClass('is-open');
            $trigger.attr('aria-expanded', 'false').trigger('focus');
        } else if (event.key === 'Home') {
            event.preventDefault();
            $options.first().trigger('focus');
        } else if (event.key === 'End') {
            event.preventDefault();
            $options.last().trigger('focus');
        } else if (event.key === 'Tab') {
            // Close dropdown when tabbing away
            $sortBySelect.removeClass('is-open');
            $trigger.attr('aria-expanded', 'false');
        }
    });

    // Sort-by initialization - set aria attributes and tabindex
    $('.sort-by-select').each(function() {
        const $sortBySelect = $(this);
        const $trigger = $sortBySelect.find('.sort-by-select__trigger');
        const $options = $sortBySelect.find('.sort-by-select__option');
        $trigger.attr('aria-expanded', 'false');
        
        // Set tabindex for all options to make them focusable
        $options.attr('tabindex', '-1');
        
        const $preSelectedOption = $options.filter('.item-selected').first();
        if ($preSelectedOption.length) {
            $preSelectedOption.attr('aria-selected', 'true');
        }
    });

    // Close sort-by dropdown when clicking outside
    $(document).on('click', function(event) {
        $('.sort-by-select.is-open').each(function() {
            const $sortBySelect = $(this);
            if (!$sortBySelect.is(event.target) && $sortBySelect.has(event.target).length === 0) {
                $sortBySelect.removeClass('is-open');
                $sortBySelect.find('.sort-by-select__trigger').attr('aria-expanded', 'false');
            }
        });
    });

    // Auto-initialize when DOM is ready
    if ($('.products-content').length || $('.sidebar__collection-filter').length) {
        window.collectionFilters = new CollectionFilters();
    }

    // Initialize fast collection links
    if ($('.collection-fast-link__container').length) {
        fastCollectionLinks.init();
    }

});
